import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './auth.guard';

import { LoginformComponent } from './loginform/loginform.component';
import { MainComponent } from './main/main.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { OrderComponent } from './order/order.component';
import { StockComponent } from './stock/stock.component';
import { ProductComponent } from './product/product.component';
import { CouponComponent } from './coupon/coupon.component';
import { DiscountsComponent } from './discounts/discounts.component';
import { ShowcaseComponent } from './showcase/showcase.component';
import { ShowcaseRegisterComponent } from './showcase-register/showcase-register.component';
import { CustomersComponent } from './customers/customers.component';
import { CustomerComponent } from './customer/customer.component';
import { SettingsComponent } from './settings/settings.component';
import { DesignComponent } from './settings/design/design.component';
import { BannerRotativeComponent } from './settings/design/banner-rotative/banner-rotative.component';
import { BannerRotativeRegisterComponent } from './settings/design/banner-rotative-register/banner-rotative-register.component';
import { ShippingDeliveryComponent } from './settings/shipping-delivery/shipping-delivery.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { PromotionComponent } from './promotion/promotion.component';
import { CouponsComponent } from './coupons/coupons.component';
import { DriveThruComponent } from './settings/drive-thru/drive-thru.component';
import { CollaboratorsComponent } from './settings/collaborators/collaborators.component';
import { ParametersComponent } from './settings/parameters/parameters.component';
import { TvDashboardComponent } from './tv-dashboard/tv-dashboard.component';
import { BannersComponent } from './settings/design/banners/banners.component';
import { BannersRegisterComponent } from './settings/design/banners-register/banners-register.component';
import { PersonalizacaoComponent } from './settings/design/personalizacao/personalizacao.component';
import { PaymentMethodsComponent } from './settings/payment-methods/payment-methods.component';

import { AccessManagerComponent } from './access-manager/access-manager.component';
import { AccessRegisterComponent } from './access-register/access-register.component';
import { CategoriesComponent } from './settings/categories/categories.component';
import { DataImportComponent } from './settings/data-import/data-import.component';
import { WelcomeComponent } from './welcome/welcome.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: 'acessar',
    component: LoginformComponent,
  },
  {
    path: 'access-register',
    component: AccessRegisterComponent,
  },
  {
    path: 'access-manager',
    component: AccessManagerComponent,
  },
  {
    path: 'app',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'visao-geral',
        pathMatch: 'full',
      },
      {
        path: 'bem-vindo',
        component: WelcomeComponent,
      },
      {
        path: 'visao-geral',
        component: DashboardComponent,
      },
      {
        path: 'configuracao-inicial',
        component: ConfigurationComponent,
      },
      {
        path: 'pedidos',
        component: OrderComponent,
      },
      {
        path: 'estoque',
        component: StockComponent,
      },
      {
        path: 'produto',
        component: ProductComponent,
      },
      {
        path: 'produto/:id/:codbarra',
        component: ProductComponent,
      },
      {
        path: 'descontos',
        component: DiscountsComponent,
      },
      {
        path: 'descontos/cupons',
        component: CouponsComponent,
      },
      {
        path: 'descontos/cupom',
        component: CouponComponent,
      },
      {
        path: 'descontos/cupom/:id',
        component: CouponComponent,
      },
      {
        path: 'vitrine',
        component: ShowcaseComponent,
      },
      {
        path: 'vitrine-cadastro',
        component: ShowcaseRegisterComponent,
      },
      {
        path: 'vitrine-cadastro/:id',
        component: ShowcaseRegisterComponent,
      },
      {
        path: 'clientes',
        component: CustomersComponent,
      },
      {
        path: 'cliente-cadastro',
        component: CustomerComponent,
      },
      {
        path: 'cliente-cadastro/:id',
        component: CustomerComponent,
      },
      {
        path: 'descontos/promocoes',
        component: PromotionsComponent,
      },
      {
        path: 'descontos/promocao',
        component: PromotionComponent,
      },
      {
        path: 'descontos/promocao/:id',
        component: PromotionComponent,
      },
      {
        path: 'configuracao',
        component: SettingsComponent,
      },
      {
        path: 'configuracao/design',
        component: DesignComponent,
      },
      {
        path: 'configuracao/design/personalizacao',
        component: PersonalizacaoComponent,
      },
      {
        path: 'configuracao/design/banner-rotativo',
        component: BannerRotativeComponent,
      },
      {
        path: 'configuracao/design/banner-rotativo-cadastro',
        component: BannerRotativeRegisterComponent,
      },
      {
        path: 'configuracao/design/banner-rotativo-cadastro/:id',
        component: BannerRotativeRegisterComponent,
      },
      {
        path: 'configuracao/design/banners',
        component: BannersComponent,
      },
      {
        path: 'configuracao/design/banners/cadastro',
        component: BannersRegisterComponent,
      },
      {
        path: 'configuracao/design/banners/cadastro/:id',
        component: BannersRegisterComponent,
      },
      {
        path: 'configuracao/frete-entrega',
        component: ShippingDeliveryComponent,
      },
      {
        path: 'configuracao/drive-thru',
        component: DriveThruComponent,
      },
      {
        path: 'configuracao/colaboradores',
        component: CollaboratorsComponent,
      },
      {
        path: 'configuracao/parametros',
        component: ParametersComponent,
      },
      {
        path: 'configuracao/metodos-de-pagamentos',
        component: PaymentMethodsComponent,
      },
      {
        path: 'configuracao/departamentos',
        component: CategoriesComponent,
      },
      {
        path: 'configuracao/importacao-de-dados',
        component: DataImportComponent,
      },
    ],
  },
  {
    path: 'tv',
    component: TvDashboardComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
export const routingComponents = [
  LoginformComponent,
  MainComponent,
  DashboardComponent,
  ConfigurationComponent,
  OrderComponent,
  StockComponent,
  ProductComponent,
  DiscountsComponent,
  CouponComponent,
  ShowcaseComponent,
  ShowcaseRegisterComponent,
  CustomersComponent,
  SettingsComponent,
  DesignComponent,
  CustomerComponent,
  ShippingDeliveryComponent,
  DriveThruComponent,
  PromotionComponent,
  PromotionsComponent,
  CouponsComponent,
  CollaboratorsComponent,
  BannerRotativeComponent,
  BannersComponent,
  BannersRegisterComponent,
  TvDashboardComponent,
  PersonalizacaoComponent,
  CategoriesComponent,
  DataImportComponent,
  WelcomeComponent,
];
